import type { Dict } from 'mixpanel-browser';

const NUMERIC_SHOP_SUPER_PROPERTIES = ['Shop Listings', 'Shop Sales'] as const;

/** Ensures shop metrics are numbers so Mixpanel numeric breakdowns work. */
export function coerceMixpanelShopMetrics(properties: Dict): Dict {
  const normalized = { ...properties };

  for (const key of NUMERIC_SHOP_SUPER_PROPERTIES) {
    if (key in normalized) {
      const value = Number(normalized[key]);
      normalized[key] = Number.isFinite(value) ? value : 0;
    }
  }

  return normalized;
}
